'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-autowhatever/dist/index.js
// module id = 214
// module chunks = 0 1